import type { AxiosInstance } from 'axios';
import { CreateLabResultInput, LabResult, LabResultList } from './types';

export class LabResultsService {
  instance: AxiosInstance;

  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  async create(input: CreateLabResultInput): Promise<LabResult> {
    const response = await this.instance.post<LabResult>('/lab-results', input);
    return response.data;
  }

  async uploadCsv(file: File): Promise<void> {
    const formData = new FormData();
    formData.append('file', file);
    await this.instance.post<LabResult>('/lab-results/uploadCsv', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }

  async getById(id: Number): Promise<LabResult> {
    const response = await this.instance.get<LabResult>(`/lab-results/${id}`);
    return response.data;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async list(page: Number): Promise<LabResultList> {
    // apply page parameter when pagination is supported by the backend
    const response = await this.instance.get<LabResultList>('/lab-results', {
      params: {
        page,
      },
    });
    return response.data;
  }
}
